import React, { useEffect, useState } from "react";
import { Severity } from "@eveworld/types";
import { useNotification, useSmartObject } from "@eveworld/contexts";

import { ErrorNotice, ErrorNoticeTypes } from "@eveworld/ui-components";

import { JSX } from "react/jsx-runtime";
import SideBarTribeMember from "./SidebarTribeMember";
import Box from "@mui/material/Box";
import BuilderSmartGates from "./builder/BuilderSmartGates";
import BuilderSmartStorageUnits from "./builder/BuilderSmartStorageUnits";
import InitVars from "../../src/InitVars";
import BuilderSmartTurrets from "./builder/BuilderSmartTurrets";
import ButtonTransferEVEBalance from "./builder/buttons/ButtonTransferEVEBalance";
import { Stack } from "@mui/material";
import ButtonCheckEveBalance from "./builder/buttons/ButtonCheckEveBalance";
import ButtonCheckAllowance from "./builder/buttons/ButtonCheckAllowance";
import ButtonApproveEveSpender from "./builder/buttons/buttonApproveEveSpender";
import ButtonCheckReapBalance from "./builder/buttons/ButtonCheckReapBalance";

const TribeMember = () //   {
: JSX.Element => {
  const { smartCharacter, loading } = useSmartObject();
  const { notify, handleClose } = useNotification();

  const [simulatedAddress, setSimulatedAddress] = useState("");

  // const [sidebarOption, setSidebarOption] = useState("");

  // function parentCallback(option: string) {
  //   if (sidebarOption != option) {
  //     setSidebarOption(option);
  //   }
  // }

  useEffect(() => {
    if (loading) {
      notify({ type: Severity.Info, message: "Loading..." });
    } else {
      const searchParams = new URLSearchParams(window.location.search);
      const value = searchParams.get("s"); //simulated character address
      setSimulatedAddress(value || ""); //Store the value in state, default to empty string if null
      handleClose();
    }
  }, [loading]);

  if ((!loading && !smartCharacter) || !smartCharacter?.isSmartCharacter) {
    return (
      <ErrorNotice
        type={ErrorNoticeTypes.MESSAGE}
        errorMessage="Unknown Character"
      />
    );
  }

  if (simulatedAddress.length == 0) {
    setSimulatedAddress(smartCharacter.address);
  }

  if (smartCharacter.corpId == "98000002") {
    return (
      <>
        <div className="container">
          <SideBarTribeMember />
          <Box
            sx={{
              height: "94vh",
              paddingLeft: 1,
            }}
          >
            <div className="grid">
              {InitVars.sidebarOption == "" && (
                <>
                  <p>Welcome {smartCharacter.name} to the Tribe Member page</p>
                  <br></br>
                  {/* <Stack direction={"row"} spacing={1}>
                    <ButtonCheckReapBalance></ButtonCheckReapBalance>
                    <ButtonCheckEveBalance></ButtonCheckEveBalance>
                    <ButtonCheckAllowance></ButtonCheckAllowance> */}
                  {/* <ButtonApproveEveSpender></ButtonApproveEveSpender> */}
                  {/* <ButtonTransferEVEBalance></ButtonTransferEVEBalance>
                  </Stack> */}
                </>
              )}
              {InitVars.sidebarOption == "BuilderSmartGates" && (
                <BuilderSmartGates
                  smartCharacterAddress={simulatedAddress}
                ></BuilderSmartGates>
              )}
              {InitVars.sidebarOption == "BuilderSmartStorageUnits" && (
                <BuilderSmartStorageUnits
                  smartCharacterAddress={simulatedAddress}
                ></BuilderSmartStorageUnits>
              )}
              {InitVars.sidebarOption == "BuilderSmartTurrets" && (
                <BuilderSmartTurrets
                  smartCharacterAddress={simulatedAddress}
                ></BuilderSmartTurrets>
              )}
            </div>
          </Box>
        </div>
      </>
    );
  } else {
    return (
      <>
        <div className="container">
          <Box
            sx={{
              height: "94vh",
              paddingLeft: 1,
            }}
          >
            <div className="grid">
              <p>
                Welcome {smartCharacter.name}, you are not a member of Reapers
                sorry
              </p>
            </div>
          </Box>
        </div>
      </>
    );
  }
};

export default React.memo(TribeMember);
